import * as React from 'react'
import type {SVGProps} from 'react'
const SvgTrackOrder = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30" {...props}>
        <path
            fill="#375481"
            fillRule="evenodd"
            d="M22.325 0a3 3 0 0 1 2.554 1.427l4.723 7.582-.012.008c.254.44.41.943.41 1.483V27c0 1.651-1.35 3-3 3H3c-1.65 0-3-1.349-3-3V10.5c0-.54.156-1.043.41-1.483l-.012-.008L5.12 1.426A3 3 0 0 1 7.675 0zM27 9.75H3a.76.76 0 0 0-.75.75V27c0 .407.344.75.75.75h24a.76.76 0 0 0 .75-.75V10.5a.76.76 0 0 0-.75-.75m-8.453 4.814c.534-.532 1.463-.534 1.997.002.267.267.412.62.412.997 0 .378-.145.73-.412 1l-6.19 6.188a1.4 1.4 0 0 1-.997.413c-.376 0-.732-.146-.999-.413v-.001l-2.901-2.903a1.38 1.38 0 0 1-.412-.994c0-.378.145-.73.412-.998.533-.537 1.463-.537 1.995 0l1.905 1.904zM13.875 2.25h-6.2a.76.76 0 0 0-.638.356L3.989 7.5h9.886zm8.45 0h-6.2V7.5h9.887l-3.043-4.881a.76.76 0 0 0-.645-.369z"
        />
    </svg>
)
export default SvgTrackOrder
